export default __webpack_public_path__ + "b74b2d7eb65a9144a3f002d879c957e2.svg";